




































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class ThreeDotsMenu extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: 'none' }) readonly fill?: string;

  get iconStyles() {
    return 'fill-rule: evenodd';
  }
}
